import { render } from "./ZodiacAndAstrology.vue?vue&type=template&id=027e6a8c&scoped=true"
import script from "./ZodiacAndAstrology.vue?vue&type=script&lang=js"
export * from "./ZodiacAndAstrology.vue?vue&type=script&lang=js"

import "./ZodiacAndAstrology.vue?vue&type=style&index=0&id=027e6a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027e6a8c"]])

export default __exports__